module.exports = __webpack_public_path__ + "6a48d5bde5949145a05dea37eb9e692f.pdf";